import { render } from "./ChooseDatabase.vue?vue&type=template&id=4ab1cc36&scoped=true"
import script from "./ChooseDatabase.vue?vue&type=script&lang=js"
export * from "./ChooseDatabase.vue?vue&type=script&lang=js"

import "./ChooseDatabase.vue?vue&type=style&index=0&id=4ab1cc36&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab1cc36"]])

export default __exports__